import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'FedraSansStd-medium';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    title: {
      fontSize: { base: '64px', md: '48px' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Trirong',
      lineHeight: { base: '67px', md: '50px' },
      fontWeight: 500,
      fontStyle: 'italic',
      color: '#EC1C2D',
    },
    titleSubText: {
      fontSize: '2rem',
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      lineHeight: '34px',
      fontWeight: 500,
      letterSpacing: ' -0.64px',
      color: '#fff',
    },
    emHeading: {
      fontSize: { base: '1.5rem', md: '2rem' },
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      lineHeight: { base: '26px', md: '34px' },
      fontWeight: 500,
      fontStyle: 'italic',
      letterSpacing: '-1.28px',
    },
    cardHeading: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: { base: '64px', md: '84px' },
      lineHeight: { base: '56px', md: '72px' },
      fontStyle: 'normal',
      color: '#F21D2E',
      fontWeight: 500,
    },
    cardSession: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: '20px',
      fontWeight: '400',
      lineHeight: '26px',
      color: 'rgba(255, 255, 255, 0.80)',
      letterSpacing: '-0.2px',
    },
    cardDesc: {
      fontSize: '16px',
      lineHeight: '20px',
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      color: 'rgba(255, 255, 255, 0.70)',
      fontWeight: 400,
    },
    cardText: {
      fontFamily: isIndian ? config.momLangFont[lang] : 'Geist',
      fontSize: '12px',
      lineHeight: '14px',
      color: 'rgba(255, 255, 255, 0.80)',
      letterSpacing: '-0.12px',
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const SilentUnderCurrentSt = {
  en: commonLangStyle({ lang: 'en' }),
  bn: commonLangStyle({ lang: 'bn' }),
  hi: commonLangStyle({
    lang: 'hi',
  }),
  te: commonLangStyle({ 
    lang: 'te',
    title: {
      ...commonLangStyle({ lang: 'te' }).title,
      fontSize: { base: '39px', md: '36px' },
      lineHeight: { base: '54px', md: '54px' },
    },
    titleSubText: {
      ...commonLangStyle({ lang: 'te' }).titleSubText,
      lineHeight: { base: '56px', md: '46px' },
    },
    cardHeading: {
      fontSize: { base: '48px', md: '60px' },
    },
  }),
  kn: commonLangStyle({ lang: 'kn' }),
  gu: commonLangStyle({ lang: 'gu' }),
  mr: commonLangStyle({ lang: 'mr' }),
  ml: commonLangStyle({ lang: 'ml' }),
  'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  zh: commonLangStyle({ lang: 'zh' }),
  it: commonLangStyle({ lang: 'it' }),
  fr: commonLangStyle({ lang: 'fr' }),
  de: commonLangStyle({ lang: 'de' }),
  es: commonLangStyle({ lang: 'es' }),
  ru: commonLangStyle({ lang: 'ru' }),
  ta: commonLangStyle({
    lang: 'ta',
    title: {
      ...commonLangStyle({ lang: 'ta' }).title,
      fontSize: { base: '2rem', md: '36px' },
      lineHeight: { base: '35px', md: '37px' },
    },
    titleSubText: {
      ...commonLangStyle({ lang: 'ta' }).titleSubText,
      fontSize: '1.5rem',
      lineHeight: '26.4px',
    },
  }),
  cn: commonLangStyle({ lang: 'cn' }),
  ar: commonLangStyle({
    lang: 'ar',
  }),
  id: commonLangStyle({ lang: 'id' }),
};
export default SilentUnderCurrentSt;
